//tslint:disable
/* oxlint-disable max-lines */

import { INextStepSchema } from './NextStepSchema';

export interface IStepSchema {
  /** Код шага **/
  code: ECode;
  /** Всякие разные дополнительные аттрибуты шага **/
  extras?: any | null;
  /** Массив зависимостей следующего шага от ответа на текущий вопрос **/
  nextStep: INextStepSchema[];
  /** Вопрос, который показывается на данном шаге **/
  questionCode: EQuestionCode;
  /** Шаг нельзя пропустить **/
  required: boolean;
}

export enum ECode {
  /** Следующий шаг отсутствует **/
  Absent = 'absent',
  /** Укажите адрес **/
  Address = 'address',
  /** «Магический шаг», во время которого фронт правит балом **/
  AddressMagic = 'addressMagic',
  /** Какая техника есть в квартире? **/
  Appliances = 'appliances',
  /** Оцените стоимость {техники и мебели} **/
  AppliancesAndFurnitureCost = 'appliancesAndFurnitureCost',
  /** Какая техника есть в квартире? (необязательный) **/
  AppliancesOptional = 'appliancesOptional',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Укажите общую площадь (от и до) **/
  AreaRange = 'areaRange',
  /** Укажите высоту потолков **/
  CeilingHeight = 'ceilingHeight',
  /** Можно с детьми? **/
  ChildrenAllowed = 'childrenAllowed',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Комфорт (необязательный) **/
  ComfortOptional = 'comfortOptional',
  /** Есть, что добавить? **/
  Comment = 'comment',
  /** Как срочно хотите совершить сделку? 3/6/12 месяцев **/
  DealPeriod = 'dealPeriod',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** Новостройка или вторичка? Или неважно **/
  FirstOrSecondExtended = 'firstOrSecondExtended',
  /** На каком этаже расположена квартира? **/
  Floor = 'floor',
  /** Сколько этажей в доме? **/
  FloorMax = 'floorMax',
  /** На каком этаже расположена квартира? (необязательный) **/
  FloorOptional = 'floorOptional',
  /** Форма отправлена **/
  FormSent = 'formSent',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Похоже, вы уже оценивали эту квартиру **/
  HasEstimation = 'hasEstimation',
  /** Укажите тип дома **/
  HouseMaterialType = 'houseMaterialType',
  /** Укажите тип дома (с вариантом «не знаю») **/
  HouseMaterialTypeDoNotKnow = 'houseMaterialTypeDoNotKnow',
  /** Вопрос, где нужно выбрать инфраструктуру **/
  Infrastructure = 'infrastructure',
  /** Вы агент по недвижимости? **/
  IsAgent = 'isAgent',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /**  **/
  IsOfferDataCorrect = 'isOfferDataCorrect',
  /** Вы знаете параметры квартиры и дома? **/
  IsOfferParamsKnown = 'isOfferParamsKnown',
  /** Уже выбрали проект дома под строительство? **/
  IsProjectExists = 'isProjectExists',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** В квартире такая планировка? **/
  Layout = 'layout',
  /** В квартире такая планировка? (необязательный) **/
  LayoutOptional = 'layoutOptional',
  /** Будете заключать договор аренды? **/
  LeaseAgreement = 'leaseAgreement',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalcony = 'loggiaOrBalcony',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalconyDoNotKnow = 'loggiaOrBalconyDoNotKnow',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  NeedLandForBuilding = 'needLandForBuilding',
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  NeedProject = 'needProject',
  /** Уточните тип недвижимости | Коммерческая **/
  ObjectTypeCommercial = 'objectTypeCommercial',
  /** Уточните тип недвижимости | Коммерческая (с готовым бизнесом) **/
  ObjectTypeCommercialWithBusiness = 'objectTypeCommercialWithBusiness',
  /** Уточните тип недвижимости | Жилая **/
  ObjectTypeFlat = 'objectTypeFlat',
  /** Уточните тип недвижимости | Загородка | Аренда и сдача **/
  ObjectTypeSuburban = 'objectTypeSuburban',
  /** Уточните тип недвижимости | Загородка | Покупка и продажа **/
  ObjectTypeSuburbanWithLand = 'objectTypeSuburbanWithLand',
  /** Выберите объявление **/
  Offer = 'offer',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Мы нашли объявления квартир с похожими параметрами. Вы хотите оценить квартиру из объявления? **/
  OffersFound = 'offersFound',
  /** В течение последних 10 лет в квартире производился капитальный ремонт? **/
  Overhaul = 'overhaul',
  /** Как срочно хотите совершить сделку? 1/2/4 недели **/
  PeriodShort = 'periodShort',
  /** Можно с животными? **/
  PetsAllowed = 'petsAllowed',
  /** Укажите номер мобильного телефона **/
  Phone = 'phone',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Укажите предпочитаемую цену (диапазон) **/
  PriceRange = 'priceRange',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи **/
  PriceRangeWithCommunal = 'priceRangeWithCommunal',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceRangeWithCommunalAndOperational = 'priceRangeWithCommunalAndOperational',
  /** Укажите предпочитаемую цену + включая коммунальные платежи **/
  PriceWithCommunal = 'priceWithCommunal',
  /** Укажите предпочитаемую цену + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceWithCommunalAndOperational = 'priceWithCommunalAndOperational',
  /** Шаг с прогресс баром **/
  ProgressBar = 'progressBar',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Уточните срок аренды **/
  RentType = 'rentType',
  /** Выберите текущий тип ремонта **/
  Repair = 'repair',
  /** Сколько лет ремонту? **/
  RepairAge = 'repairAge',
  /** Сколько лет ремонту? (необязательный) **/
  RepairAgeDoNotKnow = 'repairAgeDoNotKnow',
  /** Оцените стоимость ремонта. С учетом ремонта кухни, если он производился **/
  RepairCost = 'repairCost',
  /** Выберите текущий тип ремонта (необязательный) **/
  RepairDoNotKnow = 'repairDoNotKnow',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
  /** Укажите количество комнат. Доступен выбор нескольких **/
  RoomsCountMulti = 'roomsCountMulti',
  /** Время до центра города **/
  TimeToCenter = 'timeToCenter',
  /** Время до ближайшей станции метро **/
  TimeToMetro = 'timeToMetro',
  /** Почему вас заинтересовала оценка? **/
  ValuationReason = 'valuationReason',
  /** Хотите, чтобы с вами связался риелтор, для уточнения оценки? **/
  WantRealtor = 'wantRealtor',
  /** Вот что нашлось по вашему адресу **/
  WhatIsFoundForAddress = 'whatIsFoundForAddress',
  /** Куда выходят окна? **/
  WindowsView = 'windowsView',
  /** Продаете вместе с техникой и мебелью? **/
  WithAppliancesOrFurniture = 'withAppliancesOrFurniture',
  /** Продаете вместе с техникой и мебелью? (необязательный) **/
  WithAppliancesOrFurnitureOptional = 'withAppliancesOrFurnitureOptional',
  /** Год постройки дома **/
  YearRelease = 'yearRelease',
}
export enum EQuestionCode {
  /** Укажите адрес **/
  Address = 'address',
  /** «Магический шаг», во время которого фронт правит балом **/
  AddressMagic = 'addressMagic',
  /** Какая техника есть в квартире? **/
  Appliances = 'appliances',
  /** Оцените стоимость {техники и мебели} **/
  AppliancesAndFurnitureCost = 'appliancesAndFurnitureCost',
  /** Какая техника есть в квартире? (необязательный) **/
  AppliancesOptional = 'appliancesOptional',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Укажите общую площадь (от и до) **/
  AreaRange = 'areaRange',
  /** Укажите высоту потолков **/
  CeilingHeight = 'ceilingHeight',
  /** Можно с детьми? **/
  ChildrenAllowed = 'childrenAllowed',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Комфорт (необязательный) **/
  ComfortOptional = 'comfortOptional',
  /** Есть, что добавить? **/
  Comment = 'comment',
  /** Как срочно хотите совершить сделку? 3/6/12 месяцев **/
  DealPeriod = 'dealPeriod',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** Новостройка или вторичка? Или неважно **/
  FirstOrSecondExtended = 'firstOrSecondExtended',
  /** На каком этаже расположена квартира? **/
  Floor = 'floor',
  /** Сколько этажей в доме? **/
  FloorMax = 'floorMax',
  /** На каком этаже расположена квартира? (необязательный) **/
  FloorOptional = 'floorOptional',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Похоже, вы уже оценивали эту квартиру **/
  HasEstimation = 'hasEstimation',
  /** Укажите тип дома **/
  HouseMaterialType = 'houseMaterialType',
  /** Укажите тип дома (с вариантом «не знаю») **/
  HouseMaterialTypeDoNotKnow = 'houseMaterialTypeDoNotKnow',
  /** Вопрос, где нужно выбрать инфраструктуру **/
  Infrastructure = 'infrastructure',
  /** Вы агент по недвижимости? **/
  IsAgent = 'isAgent',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /**  **/
  IsOfferDataCorrect = 'isOfferDataCorrect',
  /** Вы знаете параметры квартиры и дома? **/
  IsOfferParamsKnown = 'isOfferParamsKnown',
  /** Уже выбрали проект дома под строительство? **/
  IsProjectExists = 'isProjectExists',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** В квартире такая планировка? **/
  Layout = 'layout',
  /** В квартире такая планировка? (необязательный) **/
  LayoutOptional = 'layoutOptional',
  /** Будете заключать договор аренды? **/
  LeaseAgreement = 'leaseAgreement',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalcony = 'loggiaOrBalcony',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalconyDoNotKnow = 'loggiaOrBalconyDoNotKnow',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  NeedLandForBuilding = 'needLandForBuilding',
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  NeedProject = 'needProject',
  /** Уточните тип недвижимости | Коммерческая **/
  ObjectTypeCommercial = 'objectTypeCommercial',
  /** Уточните тип недвижимости | Коммерческая (с готовым бизнесом) **/
  ObjectTypeCommercialWithBusiness = 'objectTypeCommercialWithBusiness',
  /** Уточните тип недвижимости | Жилая **/
  ObjectTypeFlat = 'objectTypeFlat',
  /** Уточните тип недвижимости | Загородка | Аренда и сдача **/
  ObjectTypeSuburban = 'objectTypeSuburban',
  /** Уточните тип недвижимости | Загородка | Покупка и продажа **/
  ObjectTypeSuburbanWithLand = 'objectTypeSuburbanWithLand',
  /** Выберите объявление **/
  Offer = 'offer',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Мы нашли объявления квартир с похожими параметрами. Вы хотите оценить квартиру из объявления? **/
  OffersFound = 'offersFound',
  /** В течение последних 10 лет в квартире производился капитальный ремонт? **/
  Overhaul = 'overhaul',
  /** Как срочно хотите совершить сделку? 1/2/4 недели **/
  PeriodShort = 'periodShort',
  /** Можно с животными? **/
  PetsAllowed = 'petsAllowed',
  /** Укажите номер мобильного телефона **/
  Phone = 'phone',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Укажите предпочитаемую цену (диапазон) **/
  PriceRange = 'priceRange',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи **/
  PriceRangeWithCommunal = 'priceRangeWithCommunal',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceRangeWithCommunalAndOperational = 'priceRangeWithCommunalAndOperational',
  /** Укажите предпочитаемую цену + включая коммунальные платежи **/
  PriceWithCommunal = 'priceWithCommunal',
  /** Укажите предпочитаемую цену + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceWithCommunalAndOperational = 'priceWithCommunalAndOperational',
  /** Рассчитываем оценку **/
  ProgressBar = 'progressBar',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Уточните срок аренды **/
  RentType = 'rentType',
  /** Выберите текущий тип ремонта **/
  Repair = 'repair',
  /** Сколько лет ремонту? **/
  RepairAge = 'repairAge',
  /** Сколько лет ремонту? (необязательный) **/
  RepairAgeDoNotKnow = 'repairAgeDoNotKnow',
  /** Оцените стоимость ремонта. С учетом ремонта кухни, если он производился **/
  RepairCost = 'repairCost',
  /** Выберите текущий тип ремонта (необязательный) **/
  RepairDoNotKnow = 'repairDoNotKnow',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
  /** Укажите количество комнат. Доступен выбор нескольких **/
  RoomsCountMulti = 'roomsCountMulti',
  /** Заявка отправлена **/
  Success = 'success',
  /** Время до центра города **/
  TimeToCenter = 'timeToCenter',
  /** Время до ближайшей станции метро **/
  TimeToMetro = 'timeToMetro',
  /** Почему вас заинтересовала оценка? **/
  ValuationReason = 'valuationReason',
  /** Хотите, чтобы с вами связался риелтор, для уточнения оценки? **/
  WantRealtor = 'wantRealtor',
  /** Вот что нашлось по вашему адресу **/
  WhatIsFoundForAddress = 'whatIsFoundForAddress',
  /** Куда выходят окна? **/
  WindowsView = 'windowsView',
  /** Продаете вместе с техникой и мебелью? **/
  WithAppliancesOrFurniture = 'withAppliancesOrFurniture',
  /** Продаете вместе с техникой и мебелью? (необязательный) **/
  WithAppliancesOrFurnitureOptional = 'withAppliancesOrFurnitureOptional',
  /** Год постройки дома **/
  YearRelease = 'yearRelease',
}
